import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'payment.card.holder.information.country.options.empty': {
    id: 'payment.card.holder.information.country.options.empty',
    defaultMessage: 'Choose country',
    description: 'Option for empty value on card holder information country field.',
  },
});

export default messages;
